export default {
  getIsInitialized: state => state.isInitialized,
  getIsAppLoading: state => state.isAppLoading,
  getGoogleVerifyKey: state => state.googleVerifyKey,
  getMaintenanceModeActive: state => state.maintenanceModeActive,
  getMaintenanceModeContent: state => state.maintenanceModeContent,
  getMaintenanceModeOnlyProduction: state =>
    state.maintenanceModeOnlyProduction,
};
